import { QueryClient } from '@tanstack/react-query';

export const queryClientGlobal = new QueryClient();
